import { Loading } from 'react-admin';
import Loadable from 'react-loadable';

const AuthSessionsList = Loadable({ loader: () => import('./authSessionsList'), loading: Loading });

export default { 
  list: AuthSessionsList,
};